import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { RouteErrorBoundary } from "@/components/common/RouteErrorBoundary";
import { PageLoader } from "@/components/common/PageLoader";

export const AppLayout: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="flex flex-1">
        <Navbar />
        <main className="flex-1 flex flex-col md:ml-0">
          <div className="flex-1 p-6 pt-16 md:pt-6 animate-enter">
            <div className="max-w-7xl mx-auto">
              {/* A page render error must not blank the whole app (#920). Pages
                  load their code on first visit; the navbar stays put (#995). */}
              <RouteErrorBoundary resetKey={pathname} homeHref="/" homeLabel="Go to dashboard">
                <Suspense fallback={<PageLoader />}>
                  <Outlet />
                </Suspense>
              </RouteErrorBoundary>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};
